import React, { useContext } from 'react';
import PrimaryDesktopActionBar from './PrimaryDesktopActionBar';
import SecondaryDesktopActionBar from './SecondaryDesktopActionBar';
import { ActionBarContext } from '../../ActionBarContext';
import { ActionBarProps as Props } from '../../types';

export const DesktopActionBar: React.FC<Props> = props => {
  const actionBarType = useContext(ActionBarContext);

  return actionBarType === 'secondary' ? (
    <SecondaryDesktopActionBar {...props} />
  ) : (
    <PrimaryDesktopActionBar {...props} />
  );
};
DesktopActionBar.displayName = 'DesktopActionBar';

export default DesktopActionBar;
